import { render } from "./Abnormal.vue?vue&type=template&id=fedb5336&scoped=true"
import script from "./Abnormal.vue?vue&type=script&lang=js"
export * from "./Abnormal.vue?vue&type=script&lang=js"

import "./Abnormal.vue?vue&type=style&index=0&id=fedb5336&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fedb5336"]])

export default __exports__